import { FILTER_TYPES } from 'components/FilterPod';

const filters = (getCredit) => [
  {
    title: 'شناسه حساب',
    label: 'شناسه حساب',
    keyName: 'cartableId',
    query: 'cartableId',
    id: 1,
    value: null,
    filterType: FILTER_TYPES.text,
    filterProps: { dir: 'ltr', englishNumber: true },
  },
  {
    title: 'شناسه درخواست',
    label: 'شناسه درخواست',
    keyName: 'requestId',
    query: 'requestId',
    id: 2,
    value: null,
    filterType: FILTER_TYPES.text,
    filterProps: { dir: 'ltr', englishNumber: true },
  },


  {
    title: 'تاریخ ایجاد درخواست',
    label: {
      start: 'از تاریخ',
      end: 'تا تاریخ',
    },
    keyName: 'createDate',
    query: {
      start: 'fromDate',
      end: 'toDate',
    },
    id: {
      start: 3, // fake
      end: 4, // fake
    },
    value: {
      start: null,
      end: null,
    },
    filterType: FILTER_TYPES.dateRange,
    filterProps: {
      start: {},
      end: {},
    },
  },



  {
    title: 'نوع تراکنش',
    label: 'نوع تراکنش',
    keyName: 'requestTypeCode',
    query: 'requestTypeCode',
    id: 5,
    value: null,
    filterType: FILTER_TYPES.select,
    filterProps: {
      options: [
        {
          value: 'MULTI_CONFIRMATION_TYPE_TRANSFER',
          label: 'انتقال وجه',
        },
        {
          value: 'MULTI_CONFIRMATION_TYPE_SETTLEMENT',
          label: 'برداشت وجه',
        },
        {
          value: 'MULTI_CONFIRMATION_TYPE_DELEGATION_RULE',
          label: 'تفویض وجه',
        },
        {
          value: 'MULTI_CONFIRMATION_TYPE_INVOICE',
          label: ' فاکتور',
        },
        {
          value: 'MULTI_CONFIRMATION_TYPE_PERCENT_VOUCHER',
          label: ' بن تخفیف (درصدی)',
        },
        {
          value: 'MULTI_CONFIRMATION_TYPE_AMOUNT_VOUCHER',
          label: ' بن تخفیف (مبلغی)',
        },
        {
          value: 'MULTI_CONFIRMATION_TYPE_VOUCHER',
          label: ' بن شارژ',
        },
      ],
    },
  },

  {
    title: 'وضعیت درخواست',
    label: 'وضعیت درخواست',
    keyName: 'status',
    query: 'status',
    id: 7,
    value: null,
    filterType: FILTER_TYPES.select,
    filterProps: {
      options: [
        {
          value: 'CARTABLE_REQUEST_WAITING',
          label: 'در انتظار  تایید',
        },
        {
          value: 'CARTABLE_REQUEST_CONFIRMED',
          label: 'تایید شده',
        },

        {
          value: 'CARTABLE_REQUEST_FINALIZED',
          label: 'نهایی شده',
        },
        {
          value: 'CARTABLE_REQUEST_CANCELED',
          label: 'لغو شده',
        },
        {
          value: 'CARTABLE_REQUEST_REJECTED',
          label: 'رد شده',
        },
        {
          value: 'CARTABLE_REQUEST_FAILED',
          label: 'ناموفق',
        },
        {
          value: 'CARTABLE_REQUEST_EXPIRED',
          label: 'منقضی شده',
        },
      ],
    },
  },
];

export default filters;
